module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.currentScreen
  }, [_c('div', {
    staticClass: "card__inner"
  }, [_c('vue-audio', {
    ref: "btnClick",
    attrs: {
      "file": 3,
      "redirect": _vm.redirect
    }
  }), _vm._v(" "), _c('vue-audio', {
    ref: "sufferCard",
    attrs: {
      "file": 4,
      "loop": true
    }
  }), _vm._v(" "), _c('vue-audio', {
    ref: "setUnicorn",
    attrs: {
      "file": 5,
      "redirect": _vm.redirect
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cardPageTitle[_vm.currentScreen])
    }
  }), _vm._v(" "), _c('card-spec', {
    attrs: {
      "specId": 'horseUser',
      "specCard": _vm.specUser
    }
  }), _vm._v(" "), _c('card-list', {
    attrs: {
      "horseColor": _vm.horseColor,
      "cardId": _vm.cardId,
      "itemCard": _vm.itemCard
    },
    on: {
      "update:cardId": function (cardId) { return _vm.chooseSpecialCard(cardId); }
    }
  }), _vm._v(" "), _c('card-spec', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentScreen === 'decisionCard'),
      expression: "currentScreen === 'decisionCard'"
    }],
    attrs: {
      "specId": 'horsePc',
      "specCard": _vm.specPc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card__action--button"
  }, [(_vm.currentScreen === 'card') ? [_c('button', {
    staticClass: "btn",
    class: [!_vm.isSelected ? _vm.btnStart : _vm.btnTop, _vm.disableSufferCard],
    on: {
      "click": _vm.sufferCard
    }
  }, [_c('span', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelected),
      expression: "isSelected"
    }],
    attrs: {
      "src": require("../assets/image/txt_stop.png"),
      "alt": ""
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSelected),
      expression: "!isSelected"
    }],
    attrs: {
      "src": require("../assets/image/txt_select_card.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn__decision__card am-btn-01",
    class: _vm.disableClass,
    on: {
      "click": _vm.decisionCard
    }
  }, [_vm._m(0), _c('span')])] : (_vm.isDecisionCardScreen) ? [_c('button', {
    staticClass: "btn btn__decision__card am-btn-02",
    on: {
      "click": _vm.goRace
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn__select__card am-btn-03",
    on: {
      "click": _vm.backSelectCard
    }
  }, [_vm._m(2)])] : (_vm.currentScreen === 'specialCard') ? [_vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "btn btn__decision__card am-btn-01",
    class: !_vm.isSelectedSpecialCard ? 'inactive' : '',
    on: {
      "click": _vm.decisionCard
    }
  }, [_vm._m(4)])] : _vm._e()], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_decision_card.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_decision_card_decisionCardScreen.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_select_card_decisionCardScreen.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("変更したいカード"), _c('br'), _vm._v("をクリックしてね")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_decision_card.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64431088","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = 85
// module chunks = 0